import React, { Component } from 'react';

export class SearchBar extends Component {


  state = {
    searchTerm:""
  }

  handleChange = e => {
    this.setState({ searchTerm: e.currentTarget.value });
  }
  
  handleClick = () => {
    this.props.onSearch(this.state.searchTerm);
  }

  handleKeyPress = e => {
    var code = e.keyCode || e.which;
    if (code === 13 && this.canSearch()) {
      this.handleClick();
    } 
  }

  doSearch(searchTerm) {
    this.setState({ searchTerm: searchTerm });
    this.props.onSearch(searchTerm);
  }

  canSearch = () => {
    return this.state.searchTerm && this.state.searchTerm.trim().length >= 3;
  }

  render() {
    return (
      <div className="search container">
        <div className="input-group">
          <div className="d-none d-sm-inline input-group-prepend">
            <span className="input-group-text">Search for</span>
          </div>
          <input type="text" placeholder="e.g. battery" aria-label="Search for..." className="form-control" value={this.state.searchTerm} onChange={this.handleChange} onKeyPress={this.handleKeyPress} />

          <div className="input-group-append">

            {this.state.searchTerm && <span className="input-group-text"><i className="fas fa-backspace clickable" onClick={() => this.setState({ searchTerm:""})}></i></span>}
            {this.canSearch() && <span className="input-group-text"><i className="fas fa-search clickable" onClick={this.handleClick}></i></span>}
            {!this.canSearch() && <span className="input-group-text"><i className="fas fa-search disabled" ></i></span>}
            
          </div>

          
        </div>
      </div>
    );
  }
}
